/* tslint:disable */
/* eslint-disable */
/**
 * OperatorDisplayService API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const RHIMContractsFileType = {
    PostMortem: 'PostMortem',
    ProcessData: 'ProcessData',
    ProcessMetrixFiltered: 'ProcessMetrixFiltered',
    ProcessMetrixRaw: 'ProcessMetrixRaw',
    ProcessMetrixVertex: 'ProcessMetrixVertex',
    ProcessMetrixSummary: 'ProcessMetrixSummary',
    ProcessMetrixZip: 'ProcessMetrixZip',
    Stl: 'STL',
    HarmonizedSummary: 'HarmonizedSummary',
    ProcessDataSplit: 'ProcessDataSplit',
    Pts: 'PTS',
    Clinker: 'Clinker',
    KilnFeed: 'KilnFeed',
    HotMeal: 'HotMeal',
    Lignite: 'Lignite',
    StopLogs: 'StopLogs',
    IrScan: 'IRScan',
    KilnShellCooling: 'KilnShellCooling',
    KilnProcessData: 'KilnProcessData',
    FerrotronSummary: 'FerrotronSummary',
} as const;

export type RHIMContractsFileType = typeof RHIMContractsFileType[keyof typeof RHIMContractsFileType];



export const RHIMContractsIndustry = {
    Steel: 'Steel',
    CementAndLime: 'CementAndLime',
    Nfm: 'NFM',
    Eec: 'EEC',
    Glass: 'Glass',
    Foundry: 'Foundry',
    Minerals: 'Minerals',
    ProcessIndustries: 'ProcessIndustries',
    Internal: 'Internal',
} as const;

export type RHIMContractsIndustry = typeof RHIMContractsIndustry[keyof typeof RHIMContractsIndustry];



export const RHIMContractsMaintenanceTaskSeverity = {
    None: 'None',
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
} as const;

export type RHIMContractsMaintenanceTaskSeverity = typeof RHIMContractsMaintenanceTaskSeverity[keyof typeof RHIMContractsMaintenanceTaskSeverity];



export const RHIMContractsRegionLocation = {
    Bottom: 'Bottom',
    Barrel: 'Barrel',
    Cone: 'Cone',
    ThroatIn: 'ThroatIn',
    ThroatOut: 'ThroatOut',
    Side0: 'Side0',
    Side1: 'Side1',
    Side2: 'Side2',
    Side3: 'Side3',
} as const;

export type RHIMContractsRegionLocation = typeof RHIMContractsRegionLocation[keyof typeof RHIMContractsRegionLocation];



export const RHIMContractsThresholdType = {
    Target: 'Target',
    Lower: 'Lower',
    LowerPlotBoundary: 'LowerPlotBoundary',
    Critical: 'Critical',
    UpperPlotBoundary: 'UpperPlotBoundary',
    Upper: 'Upper',
} as const;

export type RHIMContractsThresholdType = typeof RHIMContractsThresholdType[keyof typeof RHIMContractsThresholdType];



export const RHIMContractsVesselType = {
    Bof: 'BOF',
    Rh: 'RH',
    Eaf: 'EAF',
    Ladle: 'Ladle',
    Crk: 'CRK',
    Rhl: 'RHL',
    Aod: 'AOD',
    Bfr: 'BFR',
    Srf: 'SRF',
    Cou: 'COU',
    Hml: 'HML',
    Cco: 'CCO',
    Ccy: 'CCY',
    Cca: 'CCA',
    Tun: 'TUN',
    Pcg: 'PCG',
    Hof: 'HOF',
    Anf: 'ANF',
    Maf: 'MAF',
    Tif: 'TIF',
    Shf: 'SHF',
    Tlc: 'TLC',
} as const;

export type RHIMContractsVesselType = typeof RHIMContractsVesselType[keyof typeof RHIMContractsVesselType];



export const RHIMMeasurementServiceContractsDataLiningCondition = {
    Initial: 'Initial',
    NormalUsed: 'NormalUsed',
    AfterRepair: 'AfterRepair',
} as const;

export type RHIMMeasurementServiceContractsDataLiningCondition = typeof RHIMMeasurementServiceContractsDataLiningCondition[keyof typeof RHIMMeasurementServiceContractsDataLiningCondition];



export const RHIMMeasurementServiceContractsDataLiningMaintenanceType = {
    BricksChanged: 'BricksChanged',
    Gunning: 'Gunning',
    Fettling: 'Fettling',
    SlagSplashing: 'SlagSplashing',
} as const;

export type RHIMMeasurementServiceContractsDataLiningMaintenanceType = typeof RHIMMeasurementServiceContractsDataLiningMaintenanceType[keyof typeof RHIMMeasurementServiceContractsDataLiningMaintenanceType];



export const RHIMMeasurementServiceContractsDataMeasurementFileType = {
    _3d: '3d',
    Stl: 'stl',
    Pcraw: 'pcraw',
    Pcaligned: 'pcaligned',
    Pcprerendered: 'pcprerendered',
    Pcreduced: 'pcreduced',
    Rbl: 'rbl',
    Wear: 'wear',
    Pctrans: 'pctrans',
    Pcfiltered: 'pcfiltered',
    Hrrbl: 'hrrbl',
    Hrwear: 'hrwear',
    Filteredrbl: 'filteredrbl',
    Filteredhrrbl: 'filteredhrrbl',
    Filteredwear: 'filteredwear',
    Filteredhrwear: 'filteredhrwear',
    Wallplot: 'wallplot',
    Bottomplot: 'bottomplot',
    Meta: 'meta',
    Statistics: 'statistics',
    Sectioncuts: 'sectioncuts',
    Distancesplot: 'distancesplot',
    Video: 'video',
    Image: 'image',
    Segmentation: 'segmentation',
    Hrsegmentation: 'hrsegmentation',
    Report: 'report',
    Lcsvertex: 'lcsvertex',
    Ferrotronv1pointdata: 'ferrotronv1pointdata',
    Ferrotronv2pointdata: 'ferrotronv2pointdata',
    Imsipointdata: 'imsipointdata',
    Latitudepointdata: 'latitudepointdata',
    Lcssummary: 'lcssummary',
    Volumes: 'volumes',
    Watertightmesh: 'watertightmesh',
    Regionvalues: 'regionvalues',
    Regions: 'regions',
    Leicacsv: 'leicacsv',
    Las: 'las',
    E57: 'e57',
    Potree: 'potree',
    Panorama: 'panorama',
    Ply: 'ply',
    Hypraw: 'hypraw',
    Wearrate: 'wearrate',
} as const;

export type RHIMMeasurementServiceContractsDataMeasurementFileType = typeof RHIMMeasurementServiceContractsDataMeasurementFileType[keyof typeof RHIMMeasurementServiceContractsDataMeasurementFileType];



export const RHIMMeasurementServiceContractsDataVesselLining = {
    Shell: 'Shell',
    ShellInsulation: 'ShellInsulation',
    PermanentLining: 'PermanentLining',
    WearLining: 'WearLining',
} as const;

export type RHIMMeasurementServiceContractsDataVesselLining = typeof RHIMMeasurementServiceContractsDataVesselLining[keyof typeof RHIMMeasurementServiceContractsDataVesselLining];


/**
 * Defines the parameters for calculating a wear curve:  ```      liningThickness(heat) = factor * e^(exponent * heat) + offset  ```
 */
export interface RHIMOperatorDisplayServiceV1ModelsCurveModel {
    'factor': number;
    'offset': number;
    'exponent': number;
}
export interface RHIMOperatorDisplayServiceV1ModelsHistoricMeasuredPointDto {
    'heat': number;
    'liningThickness': number;
}
export interface RHIMOperatorDisplayServiceV1ModelsMaintenanceTaskDto {
    'severity': RHIMContractsMaintenanceTaskSeverity;
    'task'?: string | null;
}


export interface RHIMOperatorDisplayServiceV1ModelsMeasuredPointDto {
    'heat': number;
    'totalHeatNumber'?: number | null;
    'liningThickness': number;
    'cumulativeWear'?: number | null;
    'measurementTimestamp'?: string | null;
}

export const RHIMOperatorDisplayServiceV1ModelsMeasurementAvailability = {
    RemainingBrickLength: 'RemainingBrickLength',
    Wear: 'Wear',
    Both: 'Both',
} as const;

export type RHIMOperatorDisplayServiceV1ModelsMeasurementAvailability = typeof RHIMOperatorDisplayServiceV1ModelsMeasurementAvailability[keyof typeof RHIMOperatorDisplayServiceV1ModelsMeasurementAvailability];


export interface RHIMOperatorDisplayServiceV1ModelsMeasurementDataUploadFileInformationDto {
    'fileName'?: string | null;
    'fileExtension'?: string | null;
    'fileType': string;
    'vesselName': string;
    'vesselType': string;
    'campaign': number;
    'heat': number;
    'uploadedTime'?: string | null;
    'fileId': string;
}
export interface RHIMOperatorDisplayServiceV1ModelsMeasurementPagedFileListDto {
    'items': Array<RHIMOperatorDisplayServiceV1ModelsMeasurementDataUploadFileInformationDto>;
    'itemsCount': number;
}
export interface RHIMOperatorDisplayServiceV1ModelsMinimumMeasuredPointDto {
    /**
     * Unique identifier of the measured point
     */
    'id': string;
    /**
     * Id of the region the measured point belongs to
     */
    'regionId': string;
    /**
     * The campaign that the measured point is from
     */
    'campaign': number;
    /**
     * Heat number of the measurement
     */
    'heat': number;
    /**
     * Measured brick length
     */
    'brickLength': number;
    /**
     * Timestamp of the measurement (if available)  Expected to be stored in UTC.
     */
    'timestamp'?: string | null;
    /**
     * The R coordinate.  Has a value if !:CoordinateSystem is !:CoordinateSystem2D.RTheta
     */
    'r'?: number | null;
    /**
     * The Theta coordinate.  Has a value if !:CoordinateSystem is !:CoordinateSystem2D.RTheta or !:CoordinateSystem2D.ThetaZ
     */
    'theta'?: number | null;
    /**
     * The Z coordinate.  Has a value if !:CoordinateSystem is !:CoordinateSystem2D.ThetaZ
     */
    'z'?: number | null;
    /**
     * The X coordinate.  Has a value if !:CoordinateSystem is !:CoordinateSystem2D.XY
     */
    'x'?: number | null;
    /**
     * The Y coordinate.  Has a value if !:CoordinateSystem is !:CoordinateSystem2D.XY
     */
    'y'?: number | null;
}
export interface RHIMOperatorDisplayServiceV1ModelsOperatorDataViewModel {
    'isHeatMappingInvalidOrMissing': boolean;
    'campaign': number;
    /**
     * Retrieves the maximum heat number of all RHIM.OperatorDisplayService.V1.Models.MeasuredPointDto\">measurements</see> of all <see cref=\"P:RHIM.OperatorDisplayService.V1.Models.OperatorDataViewModel.Regions  or null if there are no measurements.
     */
    'lastHeat'?: number | null;
    /**
     * Retrieves the maximum heat number (represented as Total Heats if available) of all RHIM.OperatorDisplayService.V1.Models.MeasuredPointDto\">measurements</see> of all <see cref=\"P:RHIM.OperatorDisplayService.V1.Models.OperatorDataViewModel.Regions  or null if there are no measurements.
     */
    'lastTotalHeat'?: number | null;
    /**
     * Retrieves the timestamp of the latest RHIM.OperatorDisplayService.V1.Models.MeasuredPointDto\">measurements</see> of all <see cref=\"P:RHIM.OperatorDisplayService.V1.Models.OperatorDataViewModel.Regions  or null if there are no measurements or the measurements at the latest heat do not contain any timestamp.
     */
    'lastMeasurementTimestamp'?: string | null;
    'targetLifeTime': number;
    /**
     * Provides the average of RHIM.OperatorDisplayService.V1.Models.OperatorDataViewRegionModel.WearSpeed.  Regions where RHIM.OperatorDisplayService.V1.Models.OperatorDataViewRegionModel.WearSpeed is null are excluded from the calculation.  The result is rounded to two decimal places.  <br>      If no regions or measurements exist null is returned.  
     */
    'averageWearSpeed'?: number | null;
    /**
     * Provides the average measurement gap as defined by the last measured heat divided by the number of unique heats with measurements.  The result is rounded to two decimal places.  <br>      If no regions or measurements exist, null is returned.  
     */
    'averageMeasurementGap'?: number | null;
    /**
     * Provides the regions ordered by RHIM.OperatorDisplayService.V1.Models.OperatorDataViewRegionModel.Order.  <br>      The list is ordered during setting the value, it does not need to be ordered before hand.  <br>      Must not be null.  
     */
    'regions': Array<RHIMOperatorDisplayServiceV1ModelsOperatorDataViewRegionModel>;
}
export interface RHIMOperatorDisplayServiceV1ModelsOperatorDataViewRegionKpis {
    'wearRateAverage'?: number | null;
    'wearRateInstantaneous'?: number | null;
    'wearRateRelatedMinimum'?: number | null;
    'potentialAverage'?: number | null;
    'potentialMinimum'?: number | null;
    'thresholdTarget'?: number | null;
    'thresholdLower'?: number | null;
    'currentLiningThickness'?: number | null;
    'minimumLiningThickness'?: number | null;
    'deltaTarget'?: number | null;
    'deltaLower'?: number | null;
}
export interface RHIMOperatorDisplayServiceV1ModelsOperatorDataViewRegionModel {
    'id': string;
    'order': number;
    /**
     * @deprecated
     */
    'name': string;
    'displayName': string;
    'shortName': string;
    'brickSupplier': Array<string>;
    /**
     * Calculates the reduction of lining thickness for one measurement source.  Remaining brick length points are preferred when available; normalized wear points are used for wear-only regions.  <br>      To calculate the wear speed, first the reduction of the lining thickness between two adjacent measurements is divided by the amount of heats between those measurements.      The wear speed is defined as the average over the results of these calculations.  <para>      If no measurements exist, null is returned.  </para><br>      The calculation only works if      <list type=\"bullet\"><item>RHIM.OperatorDisplayService.V1.Models.OperatorDataViewRegionModel.InitialLiningThickness is set</item><item>the measurements are \"consistent\" / reasonable (no negative measurements, single measurement for single heat, ...)</item></list><br>  The wear speed is provided as `mm/heat`, rounded to two decimal places.  
     */
    'wearSpeed'?: number | null;
    'regionLocation': RHIMContractsRegionLocation;
    'initialLiningThickness': number;
    'criticalLiningThickness'?: number | null;
    'measurementAvailability'?: RHIMOperatorDisplayServiceV1ModelsMeasurementAvailability | null;
    /**
     * The target curve which models the nominal wear. Could be null if no target curve is configured on the region
     */
    'targetLiningThicknessCurve'?: RHIMOperatorDisplayServiceV1ModelsCurveModel | null;
    'thresholdCurves': Array<RHIMOperatorDisplayServiceV1ModelsThresholdCurveModel>;
    /**
     * Provides the (minimum) measured points (!:MinimumMeasuredPoint) ordered by RHIM.OperatorDisplayService.V1.Models.MeasuredPointDto.Heat.  <br>      The list is ordered during setting the value, it does not need to be ordered before hand.  <br>      Must not be null.  
     */
    'measuredPoints': Array<RHIMOperatorDisplayServiceV1ModelsMeasuredPointDto>;
    'historicMeasuredPoints': Array<RHIMOperatorDisplayServiceV1ModelsHistoricMeasuredPointDto>;
    'maintenanceTasks': Array<RHIMOperatorDisplayServiceV1ModelsMaintenanceTaskDto>;
    /**
     * The KPIs for the region
     */
    'kpis'?: RHIMOperatorDisplayServiceV1ModelsOperatorDataViewRegionKpis | null;
    /**
     * The KPIs calculated from cumulative wear measurements for the region.
     */
    'wearKpis'?: RHIMOperatorDisplayServiceV1ModelsOperatorDataViewRegionWearKpis | null;
}


export interface RHIMOperatorDisplayServiceV1ModelsOperatorDataViewRegionWearKpis {
    'wearRateAverage'?: number | null;
    'wearRateInstantaneous'?: number | null;
    'wearRateRelatedMaximum'?: number | null;
    'potentialAverage'?: number | null;
    'potentialRelatedMaximum'?: number | null;
    'thresholdTarget'?: number | null;
    'thresholdLower'?: number | null;
    'currentWear'?: number | null;
    'maximumWear'?: number | null;
    'deltaTarget'?: number | null;
    'deltaLower'?: number | null;
}
export interface RHIMOperatorDisplayServiceV1ModelsRegionMinimumBrickLengthDto {
    /**
     * The Id of the Region
     */
    'regionId': string;
    /**
     * Measured brick length
     */
    'minimumBrickLength': number;
}
export interface RHIMOperatorDisplayServiceV1ModelsRegionOrderAndVisibilityDto {
    'regionId': string;
    'displayName': string;
    'shortName': string;
    'order': number;
    'display': boolean;
}
export interface RHIMOperatorDisplayServiceV1ModelsRegionWithMinimumMeasuredPointsDto {
    'id': string;
    'minimumMeasuredPoint'?: RHIMOperatorDisplayServiceV1ModelsMinimumMeasuredPointDto | null;
}
export interface RHIMOperatorDisplayServiceV1ModelsThresholdCurveModel {
    'maintenanceTask'?: string | null;
    'severity': RHIMContractsMaintenanceTaskSeverity;
    'wearCurveType': RHIMContractsThresholdType;
    'factor': number;
    'offset': number;
    'exponent': number;
}


export interface RHIMOperatorDisplayServiceV1ModelsUpdateRegionOrderAndVisibilityDto {
    'regionId': string;
    'order': number;
    'display': boolean;
}
export interface RHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto {
    'updateRegionOrderAndVisibilityDtos': Array<RHIMOperatorDisplayServiceV1ModelsUpdateRegionOrderAndVisibilityDto>;
}
export interface RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto {
    /**
     * Enables the calculation of the Wear Rate Average
     */
    'enableWearRateAverage': boolean;
    /**
     * Enables the Wear Rate Instantaneous (wear rate between the last two measurements) calculation
     */
    'enableWearRateInstantaneous': boolean;
    /**
     * Enables the calculation of the Wear Rate Related to the Minimum Measurement of the campaign
     */
    'enableWearRateRelatedMinimum': boolean;
    /**
     * Enable Potential to Average (How long the campaign could go based on the average wear rate)
     */
    'enablePotentialAverage': boolean;
    /**
     * Enable Potential to Minimum (How long the campaign could go based on the minimum wear rate)
     */
    'enablePotentialMinimum': boolean;
    /**
     * Enable the calculation of the target threshold lining thickness
     */
    'enableThresholdTarget': boolean;
    /**
     * Enable the calculation of the lower threshold lining thickness
     */
    'enableThresholdLower': boolean;
    /**
     * Enables the display of the Current Lining Thickness
     */
    'enableCurrentLiningThickness': boolean;
    /**
     * Enable the display of the Minimum Lining Thickness
     */
    'enableMinimumLiningThickness': boolean;
    /**
     * Enables the calculation of the delta Lining Thickness to the target threshold
     */
    'enableDeltaTarget': boolean;
    /**
     * Enables the calculation of the delta Lining Thickness to the lower threshold
     */
    'enableDeltaLower': boolean;
}
export interface RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto {
    'visibilityWearRateAverage'?: boolean | null;
    'visibilityWearRateInstantaneous'?: boolean | null;
    'visibilityWearRateRelatedMinimum'?: boolean | null;
    'visibilityPotentialAverage'?: boolean | null;
    'visibilityPotentialMinimum'?: boolean | null;
    'visibilityThresholdTarget'?: boolean | null;
    'visibilityThresholdLower'?: boolean | null;
    'visibilityCurrentLiningThickness'?: boolean | null;
    'visibilityMinimumLiningThickness'?: boolean | null;
    'visibilityDeltaTarget'?: boolean | null;
    'visibilityDeltaLower'?: boolean | null;
}

/**
 * MeasurementFilesApi - axios parameter creator
 */
export const MeasurementFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * deletes a file
         * @summary deletes a file
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurementfilesFileid: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteMeasurementfilesFileid', 'fileId', fileId)
            const localVarPath = `/MeasurementFiles/{fileId}`
                .replace('{fileId}', encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the file data
         * @summary Retrieves the file data
         * @param {string} customerId 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesCustomeridList: async (customerId: string, take?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getMeasurementfilesCustomeridList', 'customerId', customerId)
            const localVarPath = `/MeasurementFiles/{customerId}/list`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Downloads a file
         * @summary Downloads a file
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesFileid: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getMeasurementfilesFileid', 'fileId', fileId)
            const localVarPath = `/MeasurementFiles/{fileId}`
                .replace('{fileId}', encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeasurementFilesApi - functional programming interface
 */
export const MeasurementFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeasurementFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * deletes a file
         * @summary deletes a file
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMeasurementfilesFileid(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMeasurementfilesFileid(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementFilesApi.deleteMeasurementfilesFileid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the file data
         * @summary Retrieves the file data
         * @param {string} customerId 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementfilesCustomeridList(customerId: string, take?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMOperatorDisplayServiceV1ModelsMeasurementPagedFileListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementfilesCustomeridList(customerId, take, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementFilesApi.getMeasurementfilesCustomeridList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Downloads a file
         * @summary Downloads a file
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeasurementfilesFileid(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeasurementfilesFileid(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeasurementFilesApi.getMeasurementfilesFileid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeasurementFilesApi - factory interface
 */
export const MeasurementFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeasurementFilesApiFp(configuration)
    return {
        /**
         * deletes a file
         * @summary deletes a file
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeasurementfilesFileid(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMeasurementfilesFileid(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the file data
         * @summary Retrieves the file data
         * @param {string} customerId 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesCustomeridList(customerId: string, take?: number, skip?: number, options?: RawAxiosRequestConfig): AxiosPromise<RHIMOperatorDisplayServiceV1ModelsMeasurementPagedFileListDto> {
            return localVarFp.getMeasurementfilesCustomeridList(customerId, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Downloads a file
         * @summary Downloads a file
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeasurementfilesFileid(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMeasurementfilesFileid(fileId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeasurementFilesApi - object-oriented interface
 */
export class MeasurementFilesApi extends BaseAPI {
    /**
     * deletes a file
     * @summary deletes a file
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMeasurementfilesFileid(fileId: string, options?: RawAxiosRequestConfig) {
        return MeasurementFilesApiFp(this.configuration).deleteMeasurementfilesFileid(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the file data
     * @summary Retrieves the file data
     * @param {string} customerId 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementfilesCustomeridList(customerId: string, take?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return MeasurementFilesApiFp(this.configuration).getMeasurementfilesCustomeridList(customerId, take, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Downloads a file
     * @summary Downloads a file
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeasurementfilesFileid(fileId: string, options?: RawAxiosRequestConfig) {
        return MeasurementFilesApiFp(this.configuration).getMeasurementfilesFileid(fileId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MinimumMeasuredPointsApi - axios parameter creator
 */
export const MinimumMeasuredPointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves all regions including the last minimum measured point
         * @summary Retrieves all regions including the last minimum measured point
         * @param {string} vesselId Id of the vessel for which the regions should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimummeasuredpointsVesselidLatestmeasuredpoint: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMinimummeasuredpointsVesselidLatestmeasuredpoint', 'vesselId', vesselId)
            const localVarPath = `/MinimumMeasuredPoints/{vesselId}/latestmeasuredpoint`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the min. brick length to each region for a vessel, campaign and heat. Only region with the tag MeasurementView are returned
         * @summary Returns the min. brick length to each region for a vessel, campaign and heat. Only region with the tag MeasurementView are returned
         * @param {string} vesselId Id of the vessel for which the regions should be retrieved
         * @param {number} campaign The campaign
         * @param {number} heat The heat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC: async (vesselId: string, campaign: number, heat: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC', 'vesselId', vesselId)
            // verify required parameter 'campaign' is not null or undefined
            assertParamExists('getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC', 'campaign', campaign)
            // verify required parameter 'heat' is not null or undefined
            assertParamExists('getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC', 'heat', heat)
            const localVarPath = `/MinimumMeasuredPoints/{vesselId}/minimummeasuredpointsformeasurementview/{campaign}/{heat}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaign}', encodeURIComponent(String(campaign)))
                .replace('{heat}', encodeURIComponent(String(heat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MinimumMeasuredPointsApi - functional programming interface
 */
export const MinimumMeasuredPointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MinimumMeasuredPointsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves all regions including the last minimum measured point
         * @summary Retrieves all regions including the last minimum measured point
         * @param {string} vesselId Id of the vessel for which the regions should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMinimummeasuredpointsVesselidLatestmeasuredpoint(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMOperatorDisplayServiceV1ModelsRegionWithMinimumMeasuredPointsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMinimummeasuredpointsVesselidLatestmeasuredpoint(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MinimumMeasuredPointsApi.getMinimummeasuredpointsVesselidLatestmeasuredpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the min. brick length to each region for a vessel, campaign and heat. Only region with the tag MeasurementView are returned
         * @summary Returns the min. brick length to each region for a vessel, campaign and heat. Only region with the tag MeasurementView are returned
         * @param {string} vesselId Id of the vessel for which the regions should be retrieved
         * @param {number} campaign The campaign
         * @param {number} heat The heat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC(vesselId: string, campaign: number, heat: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMOperatorDisplayServiceV1ModelsRegionMinimumBrickLengthDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC(vesselId, campaign, heat, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MinimumMeasuredPointsApi.getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MinimumMeasuredPointsApi - factory interface
 */
export const MinimumMeasuredPointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MinimumMeasuredPointsApiFp(configuration)
    return {
        /**
         * Retrieves all regions including the last minimum measured point
         * @summary Retrieves all regions including the last minimum measured point
         * @param {string} vesselId Id of the vessel for which the regions should be retrieved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimummeasuredpointsVesselidLatestmeasuredpoint(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMOperatorDisplayServiceV1ModelsRegionWithMinimumMeasuredPointsDto>> {
            return localVarFp.getMinimummeasuredpointsVesselidLatestmeasuredpoint(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the min. brick length to each region for a vessel, campaign and heat. Only region with the tag MeasurementView are returned
         * @summary Returns the min. brick length to each region for a vessel, campaign and heat. Only region with the tag MeasurementView are returned
         * @param {string} vesselId Id of the vessel for which the regions should be retrieved
         * @param {number} campaign The campaign
         * @param {number} heat The heat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC(vesselId: string, campaign: number, heat: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMOperatorDisplayServiceV1ModelsRegionMinimumBrickLengthDto>> {
            return localVarFp.getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC(vesselId, campaign, heat, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MinimumMeasuredPointsApi - object-oriented interface
 */
export class MinimumMeasuredPointsApi extends BaseAPI {
    /**
     * Retrieves all regions including the last minimum measured point
     * @summary Retrieves all regions including the last minimum measured point
     * @param {string} vesselId Id of the vessel for which the regions should be retrieved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMinimummeasuredpointsVesselidLatestmeasuredpoint(vesselId: string, options?: RawAxiosRequestConfig) {
        return MinimumMeasuredPointsApiFp(this.configuration).getMinimummeasuredpointsVesselidLatestmeasuredpoint(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the min. brick length to each region for a vessel, campaign and heat. Only region with the tag MeasurementView are returned
     * @summary Returns the min. brick length to each region for a vessel, campaign and heat. Only region with the tag MeasurementView are returned
     * @param {string} vesselId Id of the vessel for which the regions should be retrieved
     * @param {number} campaign The campaign
     * @param {number} heat The heat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC(vesselId: string, campaign: number, heat: number, options?: RawAxiosRequestConfig) {
        return MinimumMeasuredPointsApiFp(this.configuration).getMinimummeasuredpointsVesselidMinimummeasuredpointsformeasurementviewC(vesselId, campaign, heat, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OperatorDataViewApi - axios parameter creator
 */
export const OperatorDataViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API providing the data for the operator view
         * @summary API providing the data for the operator view
         * @param {string} vesselId id of the vessel for which the regions should be displayed
         * @param {number} [campaign] From which campaign the data should be shown. (This parameter is optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatordataviewVesselid: async (vesselId: string, campaign?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getOperatordataviewVesselid', 'vesselId', vesselId)
            const localVarPath = `/OperatorDataView/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API providing the available campaigns for a vessel
         * @summary API providing the available campaigns for a vessel
         * @param {string} vesselId id of the vessel for which the available campaigns should get returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatordataviewVesselidCampaign: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getOperatordataviewVesselidCampaign', 'vesselId', vesselId)
            const localVarPath = `/OperatorDataView/{vesselId}/campaign`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperatorDataViewApi - functional programming interface
 */
export const OperatorDataViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperatorDataViewApiAxiosParamCreator(configuration)
    return {
        /**
         * API providing the data for the operator view
         * @summary API providing the data for the operator view
         * @param {string} vesselId id of the vessel for which the regions should be displayed
         * @param {number} [campaign] From which campaign the data should be shown. (This parameter is optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatordataviewVesselid(vesselId: string, campaign?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMOperatorDisplayServiceV1ModelsOperatorDataViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatordataviewVesselid(vesselId, campaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorDataViewApi.getOperatordataviewVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API providing the available campaigns for a vessel
         * @summary API providing the available campaigns for a vessel
         * @param {string} vesselId id of the vessel for which the available campaigns should get returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatordataviewVesselidCampaign(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatordataviewVesselidCampaign(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OperatorDataViewApi.getOperatordataviewVesselidCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OperatorDataViewApi - factory interface
 */
export const OperatorDataViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperatorDataViewApiFp(configuration)
    return {
        /**
         * API providing the data for the operator view
         * @summary API providing the data for the operator view
         * @param {string} vesselId id of the vessel for which the regions should be displayed
         * @param {number} [campaign] From which campaign the data should be shown. (This parameter is optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatordataviewVesselid(vesselId: string, campaign?: number, options?: RawAxiosRequestConfig): AxiosPromise<RHIMOperatorDisplayServiceV1ModelsOperatorDataViewModel> {
            return localVarFp.getOperatordataviewVesselid(vesselId, campaign, options).then((request) => request(axios, basePath));
        },
        /**
         * API providing the available campaigns for a vessel
         * @summary API providing the available campaigns for a vessel
         * @param {string} vesselId id of the vessel for which the available campaigns should get returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatordataviewVesselidCampaign(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.getOperatordataviewVesselidCampaign(vesselId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperatorDataViewApi - object-oriented interface
 */
export class OperatorDataViewApi extends BaseAPI {
    /**
     * API providing the data for the operator view
     * @summary API providing the data for the operator view
     * @param {string} vesselId id of the vessel for which the regions should be displayed
     * @param {number} [campaign] From which campaign the data should be shown. (This parameter is optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOperatordataviewVesselid(vesselId: string, campaign?: number, options?: RawAxiosRequestConfig) {
        return OperatorDataViewApiFp(this.configuration).getOperatordataviewVesselid(vesselId, campaign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API providing the available campaigns for a vessel
     * @summary API providing the available campaigns for a vessel
     * @param {string} vesselId id of the vessel for which the available campaigns should get returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOperatordataviewVesselidCampaign(vesselId: string, options?: RawAxiosRequestConfig) {
        return OperatorDataViewApiFp(this.configuration).getOperatordataviewVesselidCampaign(vesselId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RegionsOrderApi - axios parameter creator
 */
export const RegionsOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the order and visibility information of regions
         * @summary Get the order and visibility information of regions
         * @param {string} vesselId To which vessel the regions are belonging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselVesselidOrder: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselVesselidOrder', 'vesselId', vesselId)
            const localVarPath = `/vessel/{vesselId}/order`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes the order and visibility of regions
         * @summary Changes the order and visibility of regions
         * @param {string} vesselId To which vessel the regions are belonging
         * @param {RHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto} [rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto] Contains the information for the update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselVesselidOrder: async (vesselId: string, rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto?: RHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselVesselidOrder', 'vesselId', vesselId)
            const localVarPath = `/vessel/{vesselId}/order`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegionsOrderApi - functional programming interface
 */
export const RegionsOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegionsOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the order and visibility information of regions
         * @summary Get the order and visibility information of regions
         * @param {string} vesselId To which vessel the regions are belonging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselVesselidOrder(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMOperatorDisplayServiceV1ModelsRegionOrderAndVisibilityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselVesselidOrder(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsOrderApi.getVesselVesselidOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Changes the order and visibility of regions
         * @summary Changes the order and visibility of regions
         * @param {string} vesselId To which vessel the regions are belonging
         * @param {RHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto} [rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto] Contains the information for the update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselVesselidOrder(vesselId: string, rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto?: RHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselVesselidOrder(vesselId, rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegionsOrderApi.putVesselVesselidOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RegionsOrderApi - factory interface
 */
export const RegionsOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegionsOrderApiFp(configuration)
    return {
        /**
         * Get the order and visibility information of regions
         * @summary Get the order and visibility information of regions
         * @param {string} vesselId To which vessel the regions are belonging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselVesselidOrder(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMOperatorDisplayServiceV1ModelsRegionOrderAndVisibilityDto>> {
            return localVarFp.getVesselVesselidOrder(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Changes the order and visibility of regions
         * @summary Changes the order and visibility of regions
         * @param {string} vesselId To which vessel the regions are belonging
         * @param {RHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto} [rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto] Contains the information for the update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselVesselidOrder(vesselId: string, rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto?: RHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselVesselidOrder(vesselId, rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegionsOrderApi - object-oriented interface
 */
export class RegionsOrderApi extends BaseAPI {
    /**
     * Get the order and visibility information of regions
     * @summary Get the order and visibility information of regions
     * @param {string} vesselId To which vessel the regions are belonging
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselVesselidOrder(vesselId: string, options?: RawAxiosRequestConfig) {
        return RegionsOrderApiFp(this.configuration).getVesselVesselidOrder(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Changes the order and visibility of regions
     * @summary Changes the order and visibility of regions
     * @param {string} vesselId To which vessel the regions are belonging
     * @param {RHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto} [rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto] Contains the information for the update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselVesselidOrder(vesselId: string, rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto?: RHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto, options?: RawAxiosRequestConfig) {
        return RegionsOrderApiFp(this.configuration).putVesselVesselidOrder(vesselId, rHIMOperatorDisplayServiceV1ModelsUpdateRegionsOrderAndVisibilityDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VesselKpiSettingsApi - axios parameter creator
 */
export const VesselKpiSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API to get KPI settings for a vessel for WMS
         * @summary API to get KPI settings for a vessel for WMS
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselkpisettingsDisplayVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselkpisettingsDisplayVesselid', 'vesselId', vesselId)
            const localVarPath = `/VesselKpiSettings/display/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get KPI settings for a vessel
         * @summary API to get KPI settings for a vessel
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselkpisettingsVesselid: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselkpisettingsVesselid', 'vesselId', vesselId)
            const localVarPath = `/VesselKpiSettings/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to upsert KPI settings for a vessel for WMS
         * @summary API to upsert KPI settings for a vessel for WMS
         * @param {string} vesselId 
         * @param {RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto} [rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselkpisettingsDisplayVesselid: async (vesselId: string, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto?: RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselkpisettingsDisplayVesselid', 'vesselId', vesselId)
            const localVarPath = `/VesselKpiSettings/display/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to upsert KPI settings for a vessel
         * @summary API to upsert KPI settings for a vessel
         * @param {string} vesselId 
         * @param {RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto} [rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselkpisettingsVesselid: async (vesselId: string, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto?: RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselkpisettingsVesselid', 'vesselId', vesselId)
            const localVarPath = `/VesselKpiSettings/{vesselId}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VesselKpiSettingsApi - functional programming interface
 */
export const VesselKpiSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VesselKpiSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * API to get KPI settings for a vessel for WMS
         * @summary API to get KPI settings for a vessel for WMS
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselkpisettingsDisplayVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselkpisettingsDisplayVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselKpiSettingsApi.getVesselkpisettingsDisplayVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get KPI settings for a vessel
         * @summary API to get KPI settings for a vessel
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselkpisettingsVesselid(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselkpisettingsVesselid(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselKpiSettingsApi.getVesselkpisettingsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to upsert KPI settings for a vessel for WMS
         * @summary API to upsert KPI settings for a vessel for WMS
         * @param {string} vesselId 
         * @param {RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto} [rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselkpisettingsDisplayVesselid(vesselId: string, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto?: RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselkpisettingsDisplayVesselid(vesselId, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselKpiSettingsApi.putVesselkpisettingsDisplayVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to upsert KPI settings for a vessel
         * @summary API to upsert KPI settings for a vessel
         * @param {string} vesselId 
         * @param {RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto} [rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselkpisettingsVesselid(vesselId: string, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto?: RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselkpisettingsVesselid(vesselId, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VesselKpiSettingsApi.putVesselkpisettingsVesselid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VesselKpiSettingsApi - factory interface
 */
export const VesselKpiSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VesselKpiSettingsApiFp(configuration)
    return {
        /**
         * API to get KPI settings for a vessel for WMS
         * @summary API to get KPI settings for a vessel for WMS
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselkpisettingsDisplayVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto> {
            return localVarFp.getVesselkpisettingsDisplayVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get KPI settings for a vessel
         * @summary API to get KPI settings for a vessel
         * @param {string} vesselId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselkpisettingsVesselid(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto> {
            return localVarFp.getVesselkpisettingsVesselid(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to upsert KPI settings for a vessel for WMS
         * @summary API to upsert KPI settings for a vessel for WMS
         * @param {string} vesselId 
         * @param {RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto} [rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselkpisettingsDisplayVesselid(vesselId: string, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto?: RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselkpisettingsDisplayVesselid(vesselId, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * API to upsert KPI settings for a vessel
         * @summary API to upsert KPI settings for a vessel
         * @param {string} vesselId 
         * @param {RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto} [rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselkpisettingsVesselid(vesselId: string, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto?: RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putVesselkpisettingsVesselid(vesselId, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VesselKpiSettingsApi - object-oriented interface
 */
export class VesselKpiSettingsApi extends BaseAPI {
    /**
     * API to get KPI settings for a vessel for WMS
     * @summary API to get KPI settings for a vessel for WMS
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselkpisettingsDisplayVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselKpiSettingsApiFp(this.configuration).getVesselkpisettingsDisplayVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get KPI settings for a vessel
     * @summary API to get KPI settings for a vessel
     * @param {string} vesselId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselkpisettingsVesselid(vesselId: string, options?: RawAxiosRequestConfig) {
        return VesselKpiSettingsApiFp(this.configuration).getVesselkpisettingsVesselid(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to upsert KPI settings for a vessel for WMS
     * @summary API to upsert KPI settings for a vessel for WMS
     * @param {string} vesselId 
     * @param {RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto} [rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselkpisettingsDisplayVesselid(vesselId: string, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto?: RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto, options?: RawAxiosRequestConfig) {
        return VesselKpiSettingsApiFp(this.configuration).putVesselkpisettingsDisplayVesselid(vesselId, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsWmsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to upsert KPI settings for a vessel
     * @summary API to upsert KPI settings for a vessel
     * @param {string} vesselId 
     * @param {RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto} [rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselkpisettingsVesselid(vesselId: string, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto?: RHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto, options?: RawAxiosRequestConfig) {
        return VesselKpiSettingsApiFp(this.configuration).putVesselkpisettingsVesselid(vesselId, rHIMOperatorDisplayServiceV1ModelsVesselKpiSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



